/*
 * @Description: 说明 全局load
 * @version: 版本 3.4
 * @Author: 作者 褚章一
 * @Date: 2020-08-11 11:47:55
 * @LastEditTime: 2020-08-11 14:57:16
 */
import Vue from 'vue';
import Load from './load.vue';
const loadBox = Vue.extend(Load);
const instance = new loadBox({
}).$mount();
const Loading = {
  open: function (options = {}) {
    options.show = true;
    for (let key in options) {
      instance[key] = options[key];
    }
    if (options) {
      document.body.appendChild(instance.$el);
    }
  },
  close: function () {
    instance.show = false;
    instance.msg = '加载中...';
  }
}
window.$load = Loading;
export default Loading;